var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.$f.isSearchShown
      ? _c("div", { staticClass: "global-search" }, [
          _c(
            "div",
            {
              staticClass: "overlay",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.$f.toggleSearch($event)
                }
              }
            },
            [_c("search-form")],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }